<template>
  <footer class="footer">
    <p class="link1">
      <!-- <a>站点地图</a> | -->
      <a href="http://tj.wuxi.gov.cn/doc/2015/07/06/388098.shtml" target="_blank" title="关于我们">关于我们</a> |
      <a href="http://tj.wuxi.gov.cn/doc/2015/07/06/388101.shtml" target="_blank" title="版权声明">版权声明</a>
      <!-- <a>我要纠错</a> -->
    </p>
    <p>无锡市统计局版权所有 &nbsp;&nbsp; 无锡市统计局主办</p>
    <p class="link1">
      电子邮箱：wxxcc@yw.tj.wuxi.gov.cn &nbsp;&nbsp;
      <a href="http://beian.miit.gov.cn" target="_blank">苏ICP备09024546号</a> &nbsp;&nbsp;
      <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32021102000707" target="_blank">公安备案号：32021102000707</a>
      &nbsp;&nbsp;
      网站标识码：3202000021
    </p>
    <p class="link1">
      <a href="https://bszs.conac.cn/sitename?method=show&amp;id=0897A0CF6AB06E10E053022819ACA6FF" target="_blank">
        <img vspace="0" hspace="0" border="0" src="https://dcs.conac.cn/image/red.png" />
      </a>
    </p>
    <p class="link">
      <a href="http://121.43.68.40/exposure/jiucuo.html?site_code=3202000021&amp;url=https%3A%2F%2Ftj.wuxi.gov.cn%2F" target="_blank">
        <img src="https://www.wuxi.gov.cn/static2016/images/jiucuo_2021.png" />
      </a>
    </p>
    <!-- <p>Copyright © 2015.Company name All rights reserved.</p>
    <p>
      <a target="_blank" href="http://tj.wuxi.gov.cn/">无锡市统计局</a>
    </p>
    <p>
      技术支持：
      <a target="_blank" href="http://www.dream-it.cn/">上海梦创双杨数据科技股份有限公司</a>
    </p>-->
  </footer>
</template>

<script setup>
</script>

<style lang="less" scoped>
  .footer {
    margin-top: 30px;
    padding: 15px;
    overflow: hidden;
    background-color: #efefef;

    p {
      color: #000;
      line-height: calc(var(--base-font-size) * 2);
      text-align: center;
    }
    a {
      color: var(--light-color);
      &:hover {
        text-decoration: underline;
      }
    }
    .link1 {
      a {
        color: #333;
        &:hover {
          color: #1561af;
        }
      }
    }
  }
</style>